import { NewPasswordFormBase } from '../../../../entities/@forms/ChangePasswordForm/ChangePasswordForm';
import {
    FormErrors,
    FormValidation,
    validateExactStringLength,
    validateForm,
    validateRequiredString,
} from '../../../../entities/@forms/FormValidation/FormValidationService';
import { passwordMinimalLength } from '../../../../entities/ResetPassword/ResetPassword';
import trans from '../../../../helpers/trans';

export type ResetPasswordFormErrors = FormErrors<NewPasswordFormBase>;

export const validateResetPasswordFormData = (formData: NewPasswordFormBase): FormValidation<ResetPasswordFormErrors> => {
    const { newPassword = '', confirmNewPassword = '' } = formData;

    const errors: ResetPasswordFormErrors = {
        newPassword: validateRequiredString('newPassword', newPassword)
            && validateExactStringLength('newPassword', newPassword, passwordMinimalLength),
        confirmNewPassword: validateRequiredString('confirmNewPassword', confirmNewPassword)
            && validateExactStringLength('confirmNewPassword', confirmNewPassword, passwordMinimalLength),
    };

    const passwordsAreNotEqual = newPassword && newPassword !== confirmNewPassword;

    if (passwordsAreNotEqual) {
        errors.confirmNewPassword = trans('errors.passwordsAreNotEqual');
    }

    return validateForm<ResetPasswordFormErrors>(errors);
};
